import { render, staticRenderFns } from "./KindsStep.vue?vue&type=template&id=79388121&"
import script from "./KindsStep.vue?vue&type=script&lang=js&"
export * from "./KindsStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports